import SocialCredential from "./base";
import CONSTANTS from "const/constants";

const Threads = SocialCredential.extend({
    parse: function (response) {
        response = Threads.__super__.parse.apply(this, arguments);

        response.name = response.threadsUsername;
        response.profileImage = response.threadsProfilePictureUrl;
        response.typeLabel = CONSTANTS.CREDENTIAL_TYPE_LABELS.THREADS;
        response.platformType = CONSTANTS.PLATFORM_TYPES.THREADS;

        return response;
    },

    isSocialMedia: function () {
        return true;
    },

    onShareSuccessful: function (response) {
        return Threads.__super__.onShareSuccessful.call(
            this,
            `shareViaThreadsCount`,
            response
        );
    }
});

export default Threads;
